<div class="jumbotron bg-transparent">
  <div class="text-center">
    <p class="display-4 head-component text-danger">
      {{"under-module-title"|translate}}
    </p>
    <p class="mat-h1">
      {{"under-module-description"|translate}}
    </p>
    <button mat-raised-button color="warn" [routerLink]="['/']">
      <mat-icon>home</mat-icon><span>{{"home"|translate}}</span>
    </button>
  </div>
</div>
